<template>
  <div class="title">
    <h1 class="title__text">
      <slot name="title"></slot>
    </h1>
    <span class="title__subtitle">
      <slot name="subtitle"></slot>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.title {
  margin-bottom: 10px;

  @media (max-width: $breakpoint) {
    text-align: center;
    margin-bottom: 26px;
  }

  &__text {
    font-size: 36px;
    font-weight: 700;

    @media (max-width: $breakpoint) {
      font-size: 28px;
      margin: 0;
    }
  }

  &__subtitle {
    font-size: 20px;
  }
}
</style>
